export default "__VITE_ASSET__DtxSy5K9__"